import {
  Gauge, Wallet, GitPullRequestArrow, FilePlus2, Handshake, BookOpenText,
  ReceiptText, Landmark, PhoneCall, Split, Scale, Database, Palette,
  Settings2, LayoutDashboard, BadgeCheck, FileSpreadsheet, Archive, Network,
} from "lucide-react";

export const ALL_ROLES = ["ceo", "admin", "rm", "dsa", "credit", "risk", "committee", "ops", "finance", "collections", "compliance"];
export const BORROWER = "borrower";
export const INTERNAL = ALL_ROLES.filter((r) => r !== "dsa" && r !== "rm");

export const NAV = [
  { group: "Portal", items: [{ to: "/portal", label: "My loans", icon: Wallet, roles: [BORROWER], testid: "nav-portal" }] },
  {
    group: "Command",
    items: [
      { to: "/", label: "CEO Cockpit", icon: Gauge, roles: ["ceo", "admin", "committee", "finance"], testid: "nav-cockpit" },
      { to: "/cfo", label: "CFO & Receivables", icon: Wallet, roles: ["finance", "admin", "ceo"], testid: "nav-cfo" },
    ],
  },
  {
    group: "Originate",
    items: [
      { to: "/pipeline3", label: "Pipeline", icon: GitPullRequestArrow, roles: ALL_ROLES, testid: "nav-pipeline3" },
      { to: "/apply", label: "New Application", icon: FilePlus2, roles: ["dsa", "rm", "admin"], testid: "nav-apply" },
      { to: "/dsa-console", label: "DSA Console", icon: Handshake, roles: ["dsa", "admin"], testid: "nav-dsa-console" },
    ],
  },
  {
    group: "Operate",
    items: [
      { to: "/book", label: "Loan Book V3", icon: BookOpenText, roles: INTERNAL, testid: "nav-book" },
      { to: "/receivables", label: "Billing & Receivables", icon: ReceiptText, roles: ["finance", "ops", "admin"], testid: "nav-receivables" },
      { to: "/recon", label: "Bank Reconciliation", icon: Landmark, roles: ["finance", "admin"], testid: "nav-recon" },
      { to: "/collections3", label: "Collections", icon: PhoneCall, roles: ["collections", "admin", "ceo", "finance", "ops"], testid: "nav-collections3" },
    ],
  },
  {
    group: "Govern",
    items: [
      { to: "/colending", label: "Co-Lending", icon: Split, roles: ["finance", "admin", "ceo"], testid: "nav-colending" },
      { to: "/regulatory", label: "Regulatory & CIC", icon: Scale, roles: ["compliance", "admin"], testid: "nav-regulatory" },
      { to: "/truth", label: "Data Truth", icon: Database, roles: INTERNAL, testid: "nav-truth" },
      { to: "/foundation", label: "Data Foundation", icon: Database, roles: INTERNAL, testid: "nav-foundation" },
      { to: "/styleguide", label: "Style Guide", icon: Palette, roles: ALL_ROLES, testid: "nav-styleguide" },
      { to: "/admin", label: "Settings & Integrations", icon: Settings2, roles: INTERNAL, testid: "nav-admin" },
    ],
  },
  {
    group: "Legacy Reports",
    items: [
      { to: "/overview", label: "Overview", icon: LayoutDashboard, roles: INTERNAL, testid: "nav-overview" },
      { to: "/approved", label: "Approved Loans", icon: BadgeCheck, roles: INTERNAL, testid: "nav-approved" },
      { to: "/portfolio", label: "Loan Book", icon: FileSpreadsheet, roles: INTERNAL, testid: "nav-portfolio" },
      { to: "/closed", label: "Closed Loans", icon: Archive, roles: INTERNAL, testid: "nav-closed" },
      { to: "/pipeline", label: "Loan Applications", icon: GitPullRequestArrow, roles: INTERNAL, testid: "nav-pipeline" },
      { to: "/dsa", label: "DSA Network", icon: Network, roles: INTERNAL, testid: "nav-dsa" },
    ],
  },
];

export const canSee = (role, item) => item.roles.includes(role);

export function firstAllowedRoute(role) {
  for (const g of NAV) for (const it of g.items) if (canSee(role, it)) return it.to;
  return "/styleguide";
}

export const ROLE_LABELS = {
  ceo: "CEO", admin: "Administrator", rm: "Relationship Manager", dsa: "DSA Partner",
  credit: "Credit", risk: "Risk", committee: "Credit Committee", ops: "Operations",
  finance: "Finance / CFO", collections: "Collections", compliance: "Compliance", borrower: "Borrower",
};
